import React from 'react';

function Header() {
  return (
    <header className='header'>
      <h1>Country Quiz</h1>
    </header>
  );
}

export default Header;
